import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import {
  Grid,
  Paper,
  Snackbar,
  CircularProgress,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import {
  selectGuest,
  selectCompany,
  selectCompanyCode,
} from '../../store/widgetSlice';

import {
  clearMessage,
  selectMessage,
  selectSeverity,
} from '../../store/authSlice';

import CardModal from '../modals/CardModal';
import RiskModal from '../modals/RiskModal';
import VerifyModal from '../modals/VerifyModal';
import RecognizeModal from '../modals/RecognizeModal';
import BackgroundModal from '../modals/BackgroundModal';
import WriteReviewModal from '../modals/WriteReviewModal';
import StatusIcon from './StatusIcon';
import logo from '../../assets/guest-ranger-logo.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      padding: [theme.spacing(2)],
    },
    maxWidth: 700,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  container: {
    minHeight: 192,
  },
  logo: {
    height: 75,
  },
  content: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  status: {
    display: 'flex',

    '& .MuiGrid-item': {
      display: 'flex',
      flexGrow: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  actions: {
    marginTop: 10,
    paddingTop: 20,
    borderTop: '1px solid rgba(112, 112, 112, 0.15)',
    flexGrow: 1,
  },
  action: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    width: '100%',
    marginBottom: theme.spacing(2),

    '&:last-child': {
      marginBottom: theme.spacing(1),
    },

    [theme.breakpoints.up('sm')]: {
      marginBottom: 0,
    },
  },
  loading: {
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
}));

export default function Widget() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const guest = useSelector(selectGuest);
  const company = useSelector(selectCompany);
  const message = useSelector(selectMessage);
  const severity = useSelector(selectSeverity);
  const companyCode = useSelector(selectCompanyCode);

  const handleClose = () => {
    dispatch(clearMessage());
  };

  return (
    <>
      <div className={classes.container}>
        <Paper className={classes.root} elevation={1}>
          <Snackbar open={!!message} autoHideDuration={6000} onClose={handleClose}>
            <Alert onClose={handleClose} severity={severity}>{message}</Alert>
          </Snackbar>
          <Grid container className={classes.content}>
            <Grid item xs={12} sm={5} justifyContent="center">
              <div className="grwidget__logo-container">
                <a className="grwidget__logo-link" href="https://guestranger.com/" target="_blank" rel="noreferrer">
                  <img className={classes.logo} src={logo} alt="Guest Ranger" />
                </a>
              </div>
            </Grid>
            { (!companyCode || company)
              ? (
                <>
                  <Grid container xs={12} sm={7} className={classes.status}>
                    { company && company.customAttributes && company.customAttributes.riskCheck
                      ? (
                        <Grid item>
                          <div className="grwidget__status-item">
                            <span className="grwidget__status-label">Risk Score</span>
                            <span className="grwidget__status-icon">
                              <StatusIcon status={guest && guest.riskVerified} />
                            </span>
                          </div>
                        </Grid>
                      ) : (
                        <>
                          <Grid item>
                            <div className="grwidget__status-item">
                              <span className="grwidget__status-label">Full Name</span>
                              <span className="grwidget__status-icon">
                                <StatusIcon status={guest && guest.nameVerified} />
                              </span>
                            </div>
                          </Grid>
                          <Grid item>
                            <div className="grwidget__status-item">
                              <span className="grwidget__status-label">Address</span>
                              <span className="grwidget__status-icon">
                                <StatusIcon status={guest && guest.addressVerified} />
                              </span>
                            </div>
                          </Grid>
                        </>
                      )}
                    { company && company.customAttributes && company.customAttributes.cardCheck
                && (company.customAttributes.cardCheck !== 'OFF' || company.customAttributes.saveCardImage)
                && (
                <Grid item>
                  <CardModal compact />
                </Grid>
                ) }
                    { company && company.customAttributes && company.customAttributes.backgroundCheck
                && (
                <Grid item>
                  <BackgroundModal />
                </Grid>
                ) }
                  </Grid>
                  <Grid container className={classes.actions}>
                    <Grid item sm={4} className={classes.action}>
                      { company && company.customAttributes && company.customAttributes.riskCheck
                        ? (
                          <RiskModal />
                        ) : (
                          <VerifyModal />
                        )}
                    </Grid>
                    <Grid item sm={4} className={classes.action}>
                      <RecognizeModal />
                    </Grid>
                    <Grid item sm={4} className={classes.action}>
                      <WriteReviewModal />
                    </Grid>
                  </Grid>
                </>
              )
              : (
                <>
                  <Grid container xs={12} sm={7} className={classes.loading}>
                    <CircularProgress size={46} className={classes.pendingProgress} />
                  </Grid>
                </>
              )}
          </Grid>
        </Paper>
      </div>
    </>
  );
}
